import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';


@Component({
  selector: 'app-new-folder-dialog',
  standalone: true,
  imports: [
    InputTextModule,
    ButtonModule,
    FormsModule,
    FloatLabelModule
  ],
  templateUrl: './name-dialog.component.html',
  styleUrl: './name-dialog.component.scss'
})
export class NameDialogComponent {
  dialogRef = inject(DynamicDialogRef<NameDialogComponent>)
  dialogConfigRef = inject(DynamicDialogConfig<NameDialogComponent>)

  inputLabel = this.dialogConfigRef.data.textInput
  completeText = this.dialogConfigRef.data.completedText
  completeIcon = this.dialogConfigRef.data.completedIcon
  name: string

  close() {
    this.dialogRef.close()
  }

  create(){
    this.dialogRef.close(this.name)
  }
}
